import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

export default function CertificatePage() {
  const { user } = useAuth();
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(null);

  useEffect(() => {
    api.get('/certificates/my')
      .then(r => setCerts(r.data))
      .catch(() => setCerts([]))
      .finally(() => setLoading(false));
  }, []);

  const download = async (slug, ref) => {
    setDownloading(slug);
    try {
      const res = await api.get(`/certificates/download/${slug}`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url; a.download = `PropertyTraining-Certificate-${ref}.pdf`;
      document.body.appendChild(a); a.click();
      document.body.removeChild(a); URL.revokeObjectURL(url);
    } catch { alert('Download failed — please try again.'); }
    finally { setDownloading(null); }
  };

  if (loading) return <div className="loading-center"><div className="spinner"/></div>;

  return (
    <div style={{ maxWidth:'760px', margin:'0 auto', padding:'48px 24px' }}>
      <h1 style={{ marginBottom:'8px' }}>My Certificates</h1>
      <p style={{ marginBottom:'32px' }}>Certificates are awarded on completion of a full course.</p>

      {certs.length === 0 ? (
        <div className="card card-p text-center">
          <p style={{ fontSize:'2rem', marginBottom:'12px' }}>🏆</p>
          <h3 style={{ marginBottom:'8px' }}>No certificates yet</h3>
          <p style={{ marginBottom:'20px' }}>Complete all lessons in a course to earn your certificate.</p>
          <Link to="/dashboard" className="btn btn-primary">Continue Learning →</Link>
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
          {certs.map(c => (
            <div key={c.id} className="card card-p" style={{ display:'flex', alignItems:'center', gap:'20px', flexWrap:'wrap' }}>
              <div style={{ width:'52px', height:'52px', borderRadius:'var(--r-lg)', background:'var(--color-primary-light)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.6rem', flexShrink:0 }}>🏆</div>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:600, fontSize:'16px', color:'var(--color-text-heading)', marginBottom:'3px' }}>{c.course_title}</div>
                <div style={{ fontSize:'13px', color:'var(--color-text-body)' }}>
                  Issued {new Date(c.issued_at).toLocaleDateString('en-GB', { day:'numeric', month:'long', year:'numeric' })} · Ref: {c.certificate_ref}
                </div>
              </div>
              <button
                className={`btn btn-primary btn-sm ${downloading===c.course_slug?'btn-loading':''}`}
                onClick={() => download(c.course_slug, c.certificate_ref)}
                disabled={!!downloading}>
                {downloading===c.course_slug ? '' : '⬇ Download PDF'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
